import React, { useEffect, useState } from 'react'
import styles from './index.module.sass'
import { Search } from '../../ui/Search'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import '../../../styles/tabs.sass'
import prev from '../../../assets/arrow_prev.svg'
import next from '../../../assets/arrow_next.svg'
import classNames from 'classnames'
import { TransactionItems } from './TransactionItems'
import {
    getTransactions,
    TransactionList,
} from '../../../services/TransactionsPageService'

const previousParams: Record<string, string>[] = []
let currentParams: Record<string, string> = {}
let page = 1

export const Transactions = () => {
    const [transactionList, setTransactions] = useState<TransactionList>({
        items: [],
        next_page_params: null,
    })
    const previousPageHandler = () => {
        if (previousParams.length > 0) {
            page = page - 1
            currentParams = previousParams.pop() || {}
            getTransactions(setTransactions, currentParams)
        }
    }

    const nextPageHandler = () => {
        if (transactionList.next_page_params) {
            previousParams.push(currentParams)
            currentParams = transactionList.next_page_params
            page = page + 1
            getTransactions(setTransactions, currentParams)
        }
    }
    useEffect(() => {
        getTransactions(setTransactions, {})
    }, [])
    const isDisabled = page == 1
    return (
        <div>
            <section className={styles.pageSection}>
                <div className={styles.headOfPage}>
                    <p>Transactions</p>
                </div>
                <Tabs>
                    <TabPanel>
                        <div className={styles.transactions}>
                            
                            <div className={styles.tableWrapper}>
                                <table className={styles.table}>
                                    <thead className={styles.tableHead}>
                                        <tr>
                                            <th className={styles.paddingitem}>
                                                Txn hash
                                            </th>
                                            <th className={styles.paddingitem}>
                                                Method
                                            </th>
                                            <th className={styles.paddingitem}>
                                                Block
                                            </th>
                                            <th className={styles.paddingitem}>
                                                From
                                            </th>
                                            <th className={styles.paddingitem}>
                                                To
                                            </th>
                                            <th
                                                className={classNames(
                                                    styles.thW12,
                                                    styles.thDefaultRight
                                                )}>
                                                Value ETH
                                            </th>
                                            <th
                                                className={classNames(
                                                    styles.th9p75,
                                                    styles.thDefaultRight
                                                )}>
                                                Fee ETH
                                            </th>
                                        </tr>
                                    </thead>
                                    <TransactionItems
                                        TransactionArray={transactionList.items}
                                        currentLocation="TransactionsPage"></TransactionItems>
                                </table>
                            </div>
                            <div className={styles.paginationButtons}>
                                <button
                                    className={styles.controlButton}
                                    disabled={isDisabled}
                                    onClick={previousPageHandler}>
                                    <img src={prev} alt="previous page" />
                                </button>
                                <div className={styles.pageNum}>{page}</div>
                                <button
                                    className={styles.controlButton}
                                    onClick={nextPageHandler}
                                    disabled={
                                        !transactionList.next_page_params
                                    }>
                                    <img src={next} alt="next page" />
                                </button>
                            </div>
                        </div>
                        
                    </TabPanel>
                </Tabs>
            </section>
        </div>
    )
}
